import type { CodeableConcept } from '@medplum/fhirtypes'
import {
  SIGNATURE_TASK_CODES,
  SignatureTaskCode,
} from '#src/models/tasks/constants.ts'
import {
  CarePlanSignatureTask,
  type CarePlanSignatureTaskParams,
} from '#src/models/tasks/signature/carePlanSignatureTask.ts'
import type { QueryTypes } from '#src/search.ts'

export class CarePlanParticipantSignatureTask extends CarePlanSignatureTask {
  static override get code(): CodeableConcept {
    return SIGNATURE_TASK_CODES[SignatureTaskCode.CARE_PLAN_PARTICIPANT]
  }

  constructor(data: CarePlanSignatureTaskParams) {
    super({
      code: CarePlanParticipantSignatureTask.code,
      ...data,
    })
  }

  static searchQuery(): QueryTypes {
    return {
      code: this.code,
    }
  }
}
